<ul *ngIf="breadcrumbs?.length" class="breadcrumbs" [ngClass]="{ 'home-icon': homeIcon }">
  <li *ngIf="homeIcon">
    <a routerLink="/"><mat-icon>home</mat-icon></a
    ><span class="material-icons">chevron_right</span>
  </li>
  <li class="links" *ngFor="let crumb of breadcrumbs; let i = index; let last = last">
    <a *ngIf="crumb.url" routerLink="{{ crumb.url }}">{{ crumb.name }}</a>
    <span *ngIf="!crumb.url">{{ crumb.name }}</span>
    <span *ngIf="!last && !homeIcon">/</span>
    <span *ngIf="!last && homeIcon"><span class="material-icons">chevron_right</span></span>
  </li>
</ul>
